import React, { Component } from 'react';
import { parsePhoneNumber } from 'libphonenumber-js';
import cx from 'classnames';
import CountryFlag from './CountryFlag';
import Input from '../../Input';

import COUNTRIES from '../constants/countries.json';
import { PHONE_NUMBER_INPUT } from '../styles/phoneNumberInput';
import { SearchableOptionsDropdown } from './SearchableOptionsDropdown';
import '../styles/_phone-number-input.scss';



























const getCountryCodeFromKey = (countryKey) => countryKey.split('_')[0];

function findInitialCountry(countries, initialCountryCode = 'AU') {
  return countries.find((countryOption) =>
  getCountryCodeFromKey(countryOption.value) === initialCountryCode
  ) || countries[0];
}

function generateCountryOptions() {
  return COUNTRIES.map((country) => ({
    label: country.name,
    value: `${country.countryCode}_${country.name}`,
    prefix: <CountryFlag code={country.countryCode} />,
    suffix: country.dialCode,
    countryPlaceholder: country.dialFormat
  }));
}

function attemptToParseNumber(number, countryCode)




{
  const defaultObj = { number, valid: false };
  // Google lib fails to parse a single digit number so we have to 'fake' it to return a number
  if (!number || number.length === 1) {return defaultObj;}

  try {
    const parsedNumber = parsePhoneNumber(number, countryCode);

    if (!parsedNumber) {return defaultObj;}
    return {
      country: parsedNumber.country,
      number: parsedNumber.number,
      nationalNumber: parsedNumber.nationalNumber,
      valid: parsedNumber.isValid()
    };
  } catch (err) {
    return defaultObj;
  }
}

export default class PhoneNumberInput extends Component


{
  static defaultProps = { initialNumber: '' };

  constructor(props) {
    super(props);

    const countries = generateCountryOptions();
    const { country, nationalNumber, number } = attemptToParseNumber(props.initialNumber);
    const initialCountry = findInitialCountry(countries, country);

    this.state = {
      countries,
      selectedCountry: initialCountry,
      number: nationalNumber || number,
      valid: true
    };
  }

  handleValidate = () => {
    const { valid, number } = this.state;
    const { onValidate, emptyIsValid } = this.props;

    if (emptyIsValid && !number) {
      return true;
    }

    if (onValidate) {onValidate(valid);}

    return valid;
  };

  updateNumber = (value) => {
    const processedNumber = value.trim().replace(/[^0-9()-]/g, '');
    this.setState({ number: processedNumber }, this.handleOnChange);
  };

  handleCountryChange = (selectedCountry) => {
    this.setState({ selectedCountry }, this.handleOnChange);
  };

  handleOnChange() {
    const { number, selectedCountry } = this.state;
    const { onChange } = this.props;
    const countryCode = getCountryCodeFromKey(selectedCountry.value);
    const { number: parsedNumber, valid } = attemptToParseNumber(number, countryCode);

    this.setState({ valid }, this.handleValidate);
    onChange(parsedNumber);
  }

  render() {
    const { id, errorMessage, placeholder, label, labelProps } = this.props;
    const { countries, number, selectedCountry } = this.state;

    return (
      <div className={cx(PHONE_NUMBER_INPUT, 'phone-number-input')}>
        <Input
          className="phone-number-input__input"
          type="tel"
          id={id}
          value={number}
          defaultValue={number}
          onChange={(e) => this.updateNumber(e.target.value)}
          validate={this.handleValidate}
          errorMessage={errorMessage}
          placeholder={selectedCountry.countryPlaceholder || placeholder}
          label={label}
          styleType="PRIMARY"
          prefixCanTakeFocus
          labelProps={labelProps}
          prefix={
          <SearchableOptionsDropdown
            options={countries}
            onChange={this.handleCountryChange}
            defaultValue={selectedCountry} />} />



      </div>);

  }
}